import { render, staticRenderFns } from "./risk-result.vue?vue&type=template&id=740c5488&"
import script from "./risk-result.vue?vue&type=script&lang=js&"
export * from "./risk-result.vue?vue&type=script&lang=js&"
import style0 from "./risk-result.vue?vue&type=style&index=0&lang=scss&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/anatec/wesave/wesave-conseil-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('740c5488', component.options)
    } else {
      api.reload('740c5488', component.options)
    }
    module.hot.accept("./risk-result.vue?vue&type=template&id=740c5488&", function () {
      api.rerender('740c5488', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/toasts/risk-result.vue"
export default component.exports